import { TranslateService } from '@ngx-translate/core';
import { blank, spf, str_len } from '../../../shared/utils/common'

export const validate_password = (value: string, args: {
  translator: TranslateService,
}): string|null => {
  if (blank(value)) {
    return 'Password must not be empty.';
  }

  if (str_len(value) < MIN_PASSWORD_LENGTH) {
    return spf(args.translator.instant('Password must be atleast %d characters long.'), {
      args: [MIN_PASSWORD_LENGTH],
    });
  }

  if (! /[a-z]/.test(value)) {
    return args.translator.instant('Password must contain atleast 1 lowercase letter.');
  }

  if (! /[A-Z]/.test(value)) {
    return args.translator.instant('Password must contain atleast 1 uppercase letter.');
  }

  if (! /[\d]/.test(value)) {
    return args.translator.instant('Password must contain atleast 1 number.');
  }

  return null;
}

const MIN_PASSWORD_LENGTH = 10;